import {
  TTechClaimIntakeClient,
  TTechClaimIntakeClientConfig,
} from "@amzn/ttechclaimintakeservice-client";
import { buildConfigForEnvironment } from "../config";

type Request = {
  headers: {
    [key: string]: string;
  };
  credentials: string;
  url?: string;
  method?: string;
  body?: any;
};

export function setupClaimIntakeClient(token: any) {
  const config: TTechClaimIntakeClientConfig = buildConfigForEnvironment();
  config.maxAttempts = 1;
  const client: TTechClaimIntakeClient = new TTechClaimIntakeClient(config);

  // Add Authorization header with Cognito JWT token
  console.log(`[setupClaimIntakeClient] Token received: ${!!token}`);
  if (token) {
    console.log(
      `[setupClaimIntakeClient] Adding Authorization header with Bearer token`,
    );
    client.middlewareStack.add(
      (next: any) => (args: any) => {
        (args.request as Request).headers["Authorization"] = "Bearer " + token;
        return next(args);
      },
      { step: "build" },
    );
  } else {
    console.log(
      `[setupClaimIntakeClient] No token provided - requests will fail authentication`,
    );
  }

  return client;
}
